import React, { useEffect } from 'react'
import create from 'zustand'
import createContext from 'zustand/context'
import shallow from 'zustand/shallow'
import { pick, flatten } from 'lodash-es'
import {
  getStageNextNodes,
  getDataStageBinding,
  postStageNode,
  postStartFlow,
} from '@vt/apis/lib-ex/v2/process'
import { useAppStore } from '../apps/app-store-provider'
import { useTbViewStore } from '../tables/views/tbview-store'
// import { fetchDataByTableDataId } from '@vt/apis/lib/v4/tables'
// import { fetchViewData } from '../../apis'

const { Provider, useStore } = createContext()

// // 重新查询当前案件信息
// const setDataById = () => {
//   return new Promise((resolve) => {
//     fetchDataByTableDataId(appId, tbId, data.tableDataId).then((result) => {
//       console.log('process-data', result)
//       setData(result)
//       onClickSubmitProcess(result)
//       resolve()
//     })
//   })
// }

const createStore = (appId) =>
  create((set, get) => {
    const setData = (data) => {
      set(() => ({ data }))
    }
    const setProcessNodes = (processNodes) => {
      set(() => ({ processNodes }))
    }
    const setOperableNodeSlugs = (operableNodeSlugs) => {
      set(() => ({ operableNodeSlugs }))
    }

    const setCurrentNode = (currentNode) => {
      set(() => ({ currentNode }))
    }
    const setIsRefreshNode = (isRefreshNode) => {
      set(() => ({ isRefreshNode }))
    }
    const setShowStartFlow = (isShowStartFlow) => {
      set(() => ({ isShowStartFlow }))
    }
    const setStageData = (stageData) => {
      set(() => ({ stageData }))
    }

    // 更新流程节点
    const updateStageNode = (updateData = {}) => {
      const { data, currentNode } = get()
      const obj = {
        objectId: data.objectId,
        identifyUuId: currentNode.uuid,
        stageId: currentNode.stageId,
      }
      return postStageNode(appId, {
        ...obj,
        ...updateData,
      })
    }

    const doOperation = (node) => {
      setCurrentNode(node)
      if (node.needForm) {
        return null
      }
      // if (!node.needForm) {
      return updateStageNode()
      // }
    }

    // 开启流程
    const startFlow = () => {
      const { data, stageData } = get()
      const arr = stageData.map((item) => {
        return postStartFlow(appId, {
          tableTemplateId: item.tbId,
          objectId: data.objectId,
          stageId: item.stageId,
        })
      })
      return Promise.all(arr)
    }

    return {
      data: null,
      stageData: [],
      processNodes: [],
      operableNodeSlugs: null,
      currentNode: null,
      isRefreshNode: true,
      isShowStartFlow: false,
      setStageData,
      setShowStartFlow,
      setIsRefreshNode,
      setData,
      setProcessNodes,
      setOperableNodeSlugs,
      setCurrentNode,
      doOperation,
      startFlow,
      updateStageNode,
    }
  })

const Consumer = function ({ children, data }) {
  const { appId } = useAppStore((x) => pick(x, ['appId']))
  // const { appId } = useAppEx()
  const { tbId } = useTbViewStore((state) => pick(state, ['tbId', 'fields']))
  const { setProcessNodes, setData, setShowStartFlow, setStageData } = useStore(
    (state) =>
      pick(state, [
        'setProcessNodes',
        'setData',
        'setShowStartFlow',
        'setStageData',
      ]),
    shallow
  )
  // 获取操作节点
  const getNodes = (stageId) => {
    return new Promise((resolve, reject) => {
      getStageNextNodes(appId, data.objectId, tbId, stageId)
        .then((res) => {
          const result = (res || []).map((item) => {
            return { ...item, stageId, isLoading: false }
          })
          resolve(result)
        })
        .catch((err) => {
          console.log(err, '开启流程')
          setShowStartFlow(true)
          reject()
        })
    })
  }

  // 当前数据变化的时候会自动请求节点接口，不需要额外的stateisRefreshNode
  useEffect(() => {
    // if (isRefreshNode) {
    // setIsRefreshNode(false)
    setData(data)
    // 获取显示的节点内容
    getDataStageBinding(appId, tbId).then((res) => {
      const arr = (res || []).map((item) => {
        return getNodes(item.stageId)
      })
      Promise.all(arr)
        .then((result) => {
          setProcessNodes(flatten(result))
        })
        .catch(() => {
          setStageData(res)
        })
    })
    // }
  }, [data])

  return children
}

export const useProcessStore = (selectors, equalityFn = shallow) =>
  useStore(selectors, equalityFn)

export const ProcessProvider = ({ children, ...props }) => {
  const { appId } = useAppStore((x) => pick(x, ['appId']))
  return (
    <Provider
      createStore={() => {
        return createStore(appId)
      }}
    >
      <Consumer {...props}>{children}</Consumer>
    </Provider>
  )
}
